import {
  takeLatest,
  put,
  putResolve,
  select,
} from 'redux-saga/effects';

import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';
import { actionLoadWireRequest } from '../actions';

import { maybeHandleCriticalErrorWithHistory } from 'react-redux-app/lib/modules/api/utils';

import { ACTION_CANCEL_WIRE__SUCCESS } from '../actionTypes';

import { getLoadWireError } from '../selectors';


function* reloadWire(history) {
  try {
    yield putResolve(actionLoadWireRequest());

    const error = yield select(getLoadWireError);
    maybeHandleCriticalErrorWithHistory(history, error?.globalErrors);
  } catch (e) {
    yield put(actionAddException(e));
  }
}

export default function* saga(history) {
  yield takeLatest([
    ACTION_CANCEL_WIRE__SUCCESS,
  ], reloadWire, history);
}
